<div class="chat-drag-boundary" #dragBoundary>
    <button class="floating-button" cdkDrag cdkDragBoundary=".chat-drag-boundary"
        [cdkDragFreeDragPosition]="launcherPosition" (cdkDragStarted)="onLauncherDragStarted()"
        (cdkDragEnded)="onLauncherDragEnded($event)" (pointerdown)="onLauncherPointerDown()"
        [title]="'CHAT_AI.OPEN_CHAT' | translate" (click)="openChatWindow()" *ngIf="!showChatWindow">
        <mat-icon svgIcon="chat-chat"></mat-icon>
    </button>
</div>

<div class="chat-position">
    <div class="chat-window" [class.chat-window-expanded]="isChatExpanded" *ngIf="showChatWindow">
        <div class="chat-header">
            <div class="chat-header-icon">
                <mat-icon svgIcon="chat-lightning"></mat-icon>
            </div>
            <div class="chat-header-title">
                {{ 'CHAT_AI.TITLE' | translate }}
            </div>

            <div class="chat-header-button-container">
                <button class="chat-delete" [title]="'CHAT_AI.DELETE_CHAT' | translate" (click)="clearChat()">
                    <mat-icon svgIcon="chat-delete"></mat-icon>
                </button>
                <button class="chat-expand-minimize" [title]="'CHAT_AI.TOGGLE_SIZE' | translate" (click)="toggleChatSize()">
                    <mat-icon svgIcon="chat-minimize" *ngIf="isChatExpanded"></mat-icon>
                    <mat-icon svgIcon="chat-maximize" *ngIf="!isChatExpanded"></mat-icon>
                </button>
                <button class="chat-exit" [title]="'CHAT_AI.EXIT_CHAT' | translate" (click)="toggleChatWindow()">
                    <mat-icon svgIcon="chat-exit"></mat-icon>
                </button>
            </div>
        </div>

        <div class="chat-body" [class.chat-body-empty]="!messages.length" #chatBody>
            <div class="chat-empty-state" *ngIf="!messages.length">
                <div class="chat-empty-icon">
                    <mat-icon svgIcon="chat-robot"></mat-icon>
                </div>
                <span>{{ 'CHAT_AI.EMPTY_STATE' | translate }}</span>

                <div class="chat-suggestions" *ngIf="exampleQuestions.length">
                    <button type="button" class="chat-suggestion" *ngFor="let question of exampleQuestions"
                        [disabled]="isSending" (click)="sendExampleQuestion(question)">
                        {{ question }}
                    </button>
                </div>
            </div>

            <div class="chat-message-list" *ngIf="messages.length">
                <lib-chat-message *ngFor="let message of messages" [message]="message"></lib-chat-message>
            </div>
        </div>

        <div class="chat-footer-container">
            <div class="chat-input">
                <input type="text" placeholder="{{ 'CHAT_AI.INPUT_PLACEHOLDER' | translate }}" [(ngModel)]="userInput"
                    [disabled]="isSending" (keyup.enter)="sendMessage()" />
                <button class="chat-send" [title]="'CHAT_AI.SEND_MESSAGE' | translate" [disabled]="isSending || !userInput.trim()"
                    (click)="sendMessage()">
                    <mat-icon svgIcon="chat-send"></mat-icon>
                </button>
            </div>
            <div class="chat-footer">
                {{ 'CHAT_AI.FOOTER' | translate }}
            </div>
        </div>

    </div>
</div>
